/** Category hero images keyed by category name. */
export const CATEGORY_FALLBACK_IMAGES = {
  Bebe: "/assets/img/product/aa/bebe/conjunto-zafary-playera-inter-pastel.png",
  Caballero: "/assets/img/product/aa/caballero/camiseta-reactivo-rojo.png",
  Dama: "/assets/img/product/aa/dama/camiseta-body-maya-reactivo-pastel-rib30-mix.png",
  Nina: "/assets/img/product/aa/nina/camiseta-picueta-rosa-rombo-blanco-blanco.png",
  Nino: "/assets/img/product/aa/nino/pijama-basica-termico-reactivo.png",
  "Unisex Adulto": "/assets/img/product/aa/unisex-adulto/kid-caramelo-6pzas.png",
  "Niño Dios": "/assets/img/product/aa/bebe/conjunto-zafary-playera-inter-pastel.png"
};
